import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IraqFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15026'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15026)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#DF1E35'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.334 6.13451C13.334 5.88788 13.5925 5.72666 13.814 5.83518L14.0997 5.97518C14.2139 6.03116 14.2864 6.14729 14.2864 6.27451V8.06664C14.2864 8.25074 14.1371 8.39998 13.953 8.39998H13.6673C13.4832 8.39998 13.334 8.25074 13.334 8.06664V6.13451Z'
					fill='#0F7A40'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61914 6.13451C7.61914 5.88788 7.87768 5.72666 8.09915 5.83518L8.38486 5.97518C8.4991 6.03116 8.57152 6.14729 8.57152 6.27451V8.06664C8.57152 8.25074 8.42228 8.39998 8.23819 8.39998H7.95247C7.76838 8.39998 7.61914 8.25074 7.61914 8.06664V6.13451Z'
					fill='#0F7A40'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4277 6.27451C11.4277 6.14729 11.5002 6.03116 11.6144 5.97518L11.9001 5.83518C12.1216 5.72666 12.3801 5.88788 12.3801 6.13451V8.06664C12.3801 8.25074 12.2309 8.39998 12.0468 8.39998H11.7611C11.577 8.39998 11.4277 8.25074 11.4277 8.06664V6.27451Z'
					fill='#0F7A40'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52344 7.20784C9.52344 7.08061 9.59585 6.96449 9.7101 6.90851L9.99581 6.76851C10.2173 6.65999 10.4758 6.82121 10.4758 7.06784V7.50844H11.9044V8.39997H10.4758H9.85677C9.67268 8.39997 9.52344 8.25073 9.52344 8.06664V7.20784Z'
					fill='#0F7A40'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71484 7.20784C5.71484 7.08061 5.78726 6.96449 5.90151 6.90851L6.18722 6.76851C6.40869 6.65999 6.66722 6.82121 6.66722 7.06784V7.50844H8.0958V8.39997H6.66722H6.04818C5.86408 8.39997 5.71484 8.25073 5.71484 8.06664V7.20784Z'
					fill='#0F7A40'
				/>
			</g>
		</svg>
	);
};

export default IraqFlagIcon;
